/* ============================================================================
 * DealDex — Garde-fou "bundle" panier (À COLLER DANS LE THÈME SHOPIFY)
 * ============================================================================
 * CE FICHIER N'EST PAS CHARGÉ PAR LE SERVEUR DEALDEX. C'est un snippet à copier
 * dans ton thème Shopify. Crée `assets/dd-cart-guard.js`, colle ce contenu, puis
 * dans `layout/theme.liquid` avant </body> :
 *     <script src="{{ 'dd-cart-guard.js' | asset_url }}" defer></script>
 *
 * OBJECTIF
 * --------
 * Le configurateur ajoute au panier un classeur (ligne PRINCIPALE, sans `_supp`) + des
 * lignes "satellite" qui portent le même `_bundle` et une propriété `_supp` :
 *   - suppléments couleur (fond / avant / arrière / tranche) -> listés dans `_supp_expected`
 *     sur la ligne classeur (obligatoires : leur retrait casse le bundle) ;
 *   - items promo b1g2 (upsell remisé) -> `_supp:'promo'`, NON listés dans `_supp_expected`
 *     (facultatifs : leur retrait ne casse rien, mais ils partent avec le classeur).
 * La ligne principale = la seule SANS `_supp`. Sans garde-fou, le client peut supprimer un
 * supplément et payer moins, ou retirer le classeur en laissant des satellites fantômes.
 *
 * RÈGLE
 * -----
 *  - Si un supplément OBLIGATOIRE (dans _supp_expected) est retiré -> on retire TOUT le bundle,
 *    puis on prévient le client (message au rechargement, pas de suppression muette).
 *  - Si le classeur (ligne principale) est retiré -> on retire ses satellites orphelins
 *    (suppléments ET promos b1g2). Les produits indépendants (sans `_bundle`) ne bougent pas.
 *
 * ⚠️ LIMITES
 * ----------
 *  - Protection CÔTÉ CLIENT, contournable (appel direct /cart/change.js, permalink,
 *    ou augmentation de la quantité du classeur). La vraie sécurité = l'alerte admin
 *    DealDex (bandeau rouge) et, pour du 100% infranchissable, une Shopify Function.
 *  - MEILLEURE OPTION UX : plutôt que de retirer le classeur quand un supplément est
 *    supprimé, CACHE carrément les lignes supplément dans le panier (elles ne peuvent
 *    alors plus être supprimées). Voir le bloc Liquid en bas de ce fichier.
 *  - Écrit pour un thème type Dawn (panier AJAX via fetch). Adapte refreshCart() au besoin.
 *  - Teste dans un thème de prévisualisation avant publication.
 * ========================================================================== */
(function () {
  'use strict';
  var BUSY = false;

  // /cart.js renvoie properties comme un OBJET { "_bundle": "b..", ... }
  function prop(item, name) {
    var p = item && item.properties;
    return (p && p[name] != null) ? String(p[name]) : '';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function refreshCart() {
    try { location.reload(); } catch (e) {}
  }

  function enforce() {
    if (BUSY) return Promise.resolve();
    BUSY = true; // verrou pris IMMÉDIATEMENT (avant l'aller-retour getCart) pour éviter les doubles passages
    return getCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) { BUSY = false; return; }

      // Regroupe les lignes par _bundle. La ligne PRINCIPALE (classeur / carte) est celle SANS
      // propriété `_supp` ; les satellites (suppléments couleur, promos b1g2) portent `_supp`.
      // Identifier le principal par l'absence de `_supp` (et non par `_supp_expected`) couvre le
      // cas d'un classeur qui n'a que des promos liées (pas de supplément couleur).
      var bundles = {};
      cart.items.forEach(function (it) {
        var b = prop(it, '_bundle');
        if (!b) return;
        if (!bundles[b]) bundles[b] = { main: null, expected: [], supps: {}, lines: [] };
        bundles[b].lines.push(it);
        var supp = prop(it, '_supp');
        if (supp) {
          bundles[b].supps[supp] = it; // satellite : supplément couleur OU promo
        } else {
          bundles[b].main = it; // ligne principale (classeur / carte)
          var exp = prop(it, '_supp_expected');
          if (exp) bundles[b].expected = exp.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        }
      });

      // Détermine les lignes à retirer + si on "casse" un classeur (=> message client).
      var toRemove = [];
      var nuked = false;
      Object.keys(bundles).forEach(function (b) {
        var bd = bundles[b];
        var hasMain = !!bd.main;
        // `expected` ne liste QUE les suppléments obligatoires (couleur). Les promos b1g2 n'y sont
        // pas → retirer un cadeau ne casse pas le classeur, mais retirer le classeur retire tout.
        var missing = (bd.expected || []).filter(function (s) { return !bd.supps[s]; });
        if (hasMain && missing.length) {
          nuked = true; // un supplément obligatoire a été retiré -> on retire tout le bundle
          bd.lines.forEach(function (l) { toRemove.push(l.key); });
        } else if (!hasMain) {
          bd.lines.forEach(function (l) { toRemove.push(l.key); }); // classeur parti -> retire suppléments + promos orphelins
        }
      });

      if (!toRemove.length) { BUSY = false; return; }

      // Coupe-circuit : si on a déjà agi il y a < 4 s, on n'entre pas dans une boucle de reload.
      try {
        var last = parseInt(sessionStorage.getItem('ddCartGuardTs') || '0', 10);
        if (Date.now() - last < 4000) { BUSY = false; return; }
      } catch (e) {}

      var chain = Promise.resolve();
      toRemove.forEach(function (key) {
        chain = chain.then(function () { return removeLine(key); });
      });
      return chain.catch(function () {}).then(function () {
        try {
          sessionStorage.setItem('ddCartGuardTs', String(Date.now()));
          if (nuked) sessionStorage.setItem('ddCartGuardMsg', '1');
        } catch (e) {}
        BUSY = false;
        refreshCart();
      });
    }).catch(function () { BUSY = false; });
  }

  // Message honnête au rechargement quand un classeur a été retiré à cause d'un supplément supprimé.
  function showMsgIfNeeded() {
    try {
      if (sessionStorage.getItem('ddCartGuardMsg') === '1') {
        sessionStorage.removeItem('ddCartGuardMsg');
        setTimeout(function () {
          alert("Ton classeur personnalisé a été retiré du panier car une option couleur (indispensable à ta personnalisation) a été supprimée. Tu peux le reconfigurer si besoin.");
        }, 400);
      }
    } catch (e) {}
  }

  var CART_RE = /\/cart\/(change|add|update|clear)\.js/;

  // Déclenche après CHAQUE mutation panier. On emballe window.fetch pour repérer /cart/*.js.
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      // Normalise l'URL (chaîne, objet {url}, ou objet URL/Request)
      var raw = arguments[0];
      var url = String((raw && raw.url) || raw || '');
      var out = _fetch.apply(this, arguments);
      if (CART_RE.test(url) && !BUSY) {
        out.then(function () { setTimeout(enforce, 150); }).catch(function () {});
      }
      return out;
    };
  }

  // v42.20 — Beaucoup de thèmes / cart-drawers mutent le panier via XMLHttpRequest (et non fetch).
  // Sans ça, supprimer le classeur ne déclenchait PAS le nettoyage des suppléments orphelins
  // (panier "vide" à l'écran mais total + compteur toujours à X€ / N articles). On intercepte donc
  // aussi XHR sur /cart/*.js.
  try {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__ddCartUrl = String(url || ''); } catch (e) {}
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        if (CART_RE.test(this.__ddCartUrl || '') && !BUSY) {
          this.addEventListener('loadend', function () { setTimeout(enforce, 150); });
        }
      } catch (e) {}
      return _send.apply(this, arguments);
    };
  } catch (e) {}

  // Filet de sécurité : re-vérifie à chaque affichage de page (navigation, retour arrière/bfcache,
  // réouverture d'onglet) → même si une mutation panier a échappé aux hooks, les orphelins partent.
  window.addEventListener('pageshow', function () { setTimeout(enforce, 300); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { showMsgIfNeeded(); setTimeout(enforce, 300); });
  } else {
    showMsgIfNeeded();
    setTimeout(enforce, 300);
  }
})();

/* ============================================================================
 * OPTION RECOMMANDÉE (meilleure UX) — CACHER les lignes supplément dans le panier
 * ============================================================================
 * Plutôt que de retirer le classeur quand un supplément est supprimé, empêche
 * carrément leur suppression en ne les affichant pas. Dans le thème Dawn, ouvre
 * `snippets/cart-drawer.liquid` ET `sections/main-cart-items.liquid` et englobe le
 * rendu de chaque ligne (`{%- for item in cart.items -%}`) d'un test qui saute les
 * lignes portant la propriété `_supp` :
 *
 *   {%- for item in cart.items -%}
 *     {%- assign _is_supp = item.properties['_supp'] -%}
 *     {%- unless _is_supp -%}
 *        ... (le rendu existant de la ligne) ...
 *     {%- endunless -%}
 *   {%- endfor -%}
 *
 * Les suppléments restent dans le total (donc payés) mais invisibles/insupprimables.
 *
 * ⚠️ PRIX AFFICHÉ SUR LA LIGNE CLASSEUR
 * -------------------------------------
 * Comme les suppléments sont des lignes séparées, la ligne classeur n'affiche que son PRIX
 * DE BASE (ex 60€) alors que le TOTAL du panier inclut les suppléments (ex 75€). Le total est
 * juste, mais pour éviter l'écart visuel il faut AFFICHER le prix bundle sur la ligne classeur.
 * Dans le rendu de la ligne classeur (celle qui a `_supp_expected`), remplace l'affichage du
 * prix (`{{ item.final_line_price | money }}`) par ce calcul qui rajoute les suppléments du
 * même `_bundle` :
 *
 *   {%- assign _bundle = item.properties['_bundle'] -%}
 *   {%- assign _supp_total = 0 -%}
 *   {%- if _bundle != blank -%}
 *     {%- for it in cart.items -%}
 *       {%- if it.properties['_bundle'] == _bundle and it.properties['_supp'] != blank -%}
 *         {%- assign _supp_total = _supp_total | plus: it.final_line_price -%}
 *       {%- endif -%}
 *     {%- endfor -%}
 *   {%- endif -%}
 *   {%- assign _line_display = item.final_line_price | plus: _supp_total -%}
 *   {{ _line_display | money }}   {%- comment -%} = classeur + ses suppléments {%- endcomment -%}
 *
 * Résultat page panier : classeur = 75€, suppléments cachés, total = 75€ → cohérent.
 * (Au checkout Shopify, le détail des lignes réapparaît — transparent, et non supprimable.)
 * Combiné au JS, tu es couvert des deux côtés.
 * ========================================================================== */
